import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';

import useTable from "../components/useTable";
import Controls from "../components/controls/Controls";
import { Dimmer } from '../components/spinner';

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from 'axios';

const CatalagoRentasInmo = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [activo, setActivo] = useState(true);

    const headCells = [
        { id: 'idinmueble', label: 'COD. INMUEBLE', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'cedrif', label: 'CEDULA/RIF', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'nombrearrendatario', label: 'NOMBRE', width: '300px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        //{ id: 'direccion', label: 'DIRECCION', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'idrentas', label: 'CODIGO', width: '10px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
    ]

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idrentas.includes(target.value)
                            || x.cedrif.toLowerCase().includes(target.value.toLowerCase())
                            || x.nombrearrendatario.toLowerCase().includes(target.value.toLowerCase())
                            //|| (x.codigocatastral !== null ? x.codigocatastral : '').toLowerCase().includes(target.value.toLowerCase())
                            || x.idinmueble.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }


    const seleccionarRentasTodas = () => {

        let campos = "*"
        let nomtab = "rentasinmobiliarias";
        let condi = "codigoimpuesto = " + props.codimpu;
        let orden = "idrentas";

        let endpoint = op.conexion + `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                setRecords(response.data)
            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }


    const handleCloseMensa = () => {
        setMostrar(false);
        seleccionarRentasTodas();
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelaCatRenta();
    }

    const seleccionarLista = (index) => (event) => {


        blanquear();
        if (props.caja) {
            props.onHideAceptaCatRenta(values[0])
        } else {
            props.onHideAceptaCatRenta(values[0].idRenta, values[0].nombre, values[0].codinmue, values[0].cedula);

        }
    };


    const seleccionarFila = (index) => (event) => {

        setItemSelect(index);
        setActivo(false);
        var idRenta = recordsAfterPagingAndSorting()[index].idrentas;
        var nombre = recordsAfterPagingAndSorting()[index].nombrearrendatario;
        var codinmue = recordsAfterPagingAndSorting()[index].idinmueble;
        var cedula = recordsAfterPagingAndSorting()[index].cedrif;

        var datos = [];

        datos.push({
            idRenta,
            nombre,
            codinmue,
            cedula
        })
        setValues(datos);
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarRentasTodas()
            }}
        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>Seleccionar rentas.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idcomercio} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "80px" }}>{item.idinmueble}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "80px" }}>{item.cedrif}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "300px" }}>{item.nombrearrendatario}</td>
                                        {/*<td style={{ fontSize: "10px", textAlign: "center", width: "80px" }}>{item.direccion}</td>*/}
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "10px" }}>{item.idrentas}</td>
                                        {/* <td align="center" style={{ fontSize: "10px", textAlign: "center", width: "120px", padding: 0, verticalAlign: "middle" }}>
                                            <button style={{ width: "120px" }} onClick={seleccionarLista(index)} className="btn btn-outline-info"><i className="fas fa-edit">Seleccionar</i> </button>
                                        </td> */}
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={seleccionarLista()}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-2"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalagoRentasInmo;